<template>
    <v-card>
         <v-toolbar
        color="primary"
        dark
        >
            <v-toolbar-title>
                Retirada do dinheiro
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text v-if="frentistaDetalhes">
          <h3 class="mt-2" v-html="text" :style="{ 'color': !frentistaDetalhes.username_picpay ? 'red' : 'gray'  }">
            {{text}}'}}
          </h3>
          <template v-if="!frentistaDetalhes.username_picpay">
            <h2 class="display-1 font-weight-light primary--text mt-4" style="text-align: center">Cadastre para continuar</h2>
            <v-container grid-list-md>
                <v-layout wrap>
            <v-flex xs12>
                <v-text-field
                    v-model="username_picpay"
                    class="pb-3 mt-4"
                    hide-details
                    box label="Nome de usuário picpay"
                />
            </v-flex>
            </v-layout>
            </v-container>
          </template>
        </v-card-text>
        <v-card-actions v-if="frentistaDetalhes">
            <v-btn class="ma-2" round @click="$emit('fechar')">Voltar</v-btn>
            <v-spacer></v-spacer>
              <v-btn v-if="frentistaDetalhes.username_picpay" :disabled="(dia < 5 || dia > 10) || frentistaSelecionado.valor_acumulado < 100 " class="ma-2" round color="primary" @click="dialog=true">Confirmar</v-btn>
              <v-btn v-else class="ma-2" round color="primary" @click="dialog=true">Cadastrar</v-btn>
        </v-card-actions>
        <v-dialog v-model="dialog" persistent max-width="400">
            <pin v-if="dialog" @autenticado="opcao" :frentistaSelecionado="frentistaSelecionado" @fechar="dialog = false"/>
        </v-dialog>
    </v-card>
</template>

<script>

import Pin from '@/components/dialogs/DialogPin'

export default {
  props: [ 'frentistaSelecionado' ],
  data () {
    return {
      dia: new Date().getDate(),
      username_picpay: '',
      dialog: false,
      frentistaDetalhes: null,
      text: 'Obs: Você só poderá solicitar retirada entre os dias cinco e dez de cada mês e se o valor a ser retirado for no mínimo R$ 100,00. <br>Para o recebimento do dinheiro é necessário uma conta PicPay.'
    }
  },
  components: { Pin },
  methods: {
    opcao () {
      if (this.frentistaDetalhes.username_picpay) {
        this.confirmar()
      } else {
        this.cadastra()
      }
    },
    confirmar () {
      this.$store.dispatch('solicitarRetirada', { 'id_frentista': this.frentistaSelecionado.id_frentista, 'cnpj': this.frentista.posto.cnpj }).then(() => {
        this.fechar()
      })
    },
    cadastra () {
      if (this.username_picpay) {
        this.$store.dispatch('programaIncentivo', { 'id_frentista': this.frentistaSelecionado.id_frentista, 'cnpj': this.frentista.posto.cnpj, 'username_picpay': this.username_picpay }).then(() => {
          this.carregarFrentista()
        })
      }
    },
    fechar () {
      this.frentistaDetalhes = null
      this.username_picpay = ''
      this.$emit('fechar')
    },
    carregarFrentista () {
      this.$store.dispatch('detalhesFrentista', { 'id': this.frentistaSelecionado.id_frentista }).then(value => {
        this.frentistaDetalhes = value
        this.text = value.username_picpay ? 'Obs: Você só poderá solicitar retirada entre os dias cinco e dez de cada mês e se o valor a ser retirado for no mínimo R$ 100,00. <br>Para o recebimento do dinheiro é necessário uma conta PicPay.' : '*Para retirar seu dinhero primeiro cadastre sua conta picpay'
      })
    }
  },
  mounted () {
    if (this.frentistaSelecionado) {
      this.frentistaDetalhes = this.frentistaSelecionado
      this.text = this.frentistaDetalhes.username_picpay ? 'Obs: Você só poderá solicitar retirada entre os dias cinco e dez de cada mês e se o valor a ser retirado for no mínimo R$ 100,00. <br>Para o recebimento do dinheiro é necessário uma conta PicPay.' : '*Para retirar seu dinhero primeiro cadastre sua conta picpay'
    }
    if (this.dia && (this.dia < 5 || this.dia > 10)) {
      this.texto = 'Você só pode solitar emtre o dia 5 e 10 de cada mês'
    }
  },
  computed: {
    frentista () {
      return this.$store.getters.frentista
    }
  }
}
</script>
